import request from '@/utils/request'

export function getList (data) {
  return request({
    url: '/getDemoById', // 后端接口
    method: 'post',
    data
  })
}
